<template>

    <div class="agent-page">
        <div class="page-header">
        <div style="display: flex; flex-direction: column; text-align: start;" >
            <h2 class="page-title">{{ pageTitle }}</h2>
            <h2 class="page-title" style="margin-top: 10px;">招标文件管理</h2>
        </div>
        </div>
        <!-- 搜索区域 -->
        <div class="search-section">
            <div class="search-form">
                <label class="search-label">标段名称:</label>
                <el-input v-model="searchForm.sectionName" placeholder="请输入标段名称" class="search-input" clearable />
                <el-button type="primary" icon="el-icon-search" @click="handleSearch" class="search-btn">
                    搜索
                </el-button>
            </div>
            <div style="display: flex; align-items: center;">
                <el-button type="primary" icon="el-icon-plus" @click="handleAdd">创建标书文件</el-button>
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>

            </div>
        </div>
        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column type="index" width="70" label="NO.">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="bidInvitationDocumentsName" label="文件名称" show-overflow-tooltip />
                <el-table-column label="标段名称" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.row.bidSectionList && scope.row.bidSectionList.length > 0"
                            class="section-names">
                            <div v-for="(section, index) in scope.row.bidSectionList" :key="index" class="section-item">
                                {{ section.bidSectionName }}
                            </div>
                        </div>
                        <span v-else>-</span>
                    </template>
                </el-table-column>

                <el-table-column prop="bidInvitationDocumentsCode" label="文件编码" show-overflow-tooltip />
                <el-table-column label="投标文件递交截止时间(开标时间)" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.bidOpeningTime }}
                    </template>
                </el-table-column>
                <el-table-column label="投标文件解密截止时间" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.decryptionDeadline }}
                    </template>
                </el-table-column>
                <el-table-column label="招标文件上传时间" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.createTime || '-' }}
                    </template>
                </el-table-column>
                <el-table-column label="详细信息" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleViewDetails(scope.row)" class="action-btn">
                            详情
                        </el-button>
                        <el-button type="text" size="small" @click="handleDownloadFile(scope.row)" class="action-btn">
                            下载文件
                        </el-button>
                        <el-button type="text" size="small" @click="handleDeleteFile(scope.row)" class="action-btn"
                            v-if="scope.row.status != 1">
                            删除
                        </el-button>
                        <el-button type="text" size="small" @click="handleEditFile(scope.row)" class="action-btn"
                            v-if="scope.row.status != 1">
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>

        <!-- 下载文件弹窗 -->
        <el-dialog title="文件下载" :visible.sync="downloadDialogVisible" width="800px" :close-on-click-modal="false"
            :append-to-body="true">
            <el-table :data="downloadFileList" border stripe v-loading="downloadLoading">
                <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
                <el-table-column label="文件名" prop="fileName" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column label="文件类型" prop="fileExtension" width="100" align="center"></el-table-column>
                <el-table-column label="文件大小" prop="fileSize" width="120" align="center">
                    <template slot-scope="scope">
                        {{ formatFileSize(scope.row.fileSize) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="handleDownloadSingleFile(scope.row)">
                            下载
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="downloadDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { getProjectDetail, getBidInvitationDocumentsList, deleteBidInvitationDocuments } from '@/api/agent/api'
import { getProjectTypeName, timeUtils } from '@/utils/base'

import { getFileList } from '@/api/base/api'
export default {

    data() {
        return {
            // 页面基础信息
            pageTitle: '',
            projectCode: '',

            // 项目详情数据
            projectDetail: {},
            // 搜索表单
            searchForm: {
                sectionName: ''
            },
            // 加载状态
            loading: false,
            // 表格数据
            tableData: [],
            // 分页信息
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 1
            },
            // 下载弹窗相关
            downloadDialogVisible: false,
            downloadLoading: false,
            downloadFileList: []
        }
    },
    mounted() {
        this.initPage()
    },
    methods: {
        /**
         * 初始化页面
         */
        initPage() {
            const projectCode = this.$route.query.projectCode
            if (!projectCode) {
                this.$message.error('缺少项目编号参数')
                this.$router.go(-1)
                return
            }
            this.projectCode = projectCode
            this.loadProjectDetail()
            this.loadBidInvitationDocumentsList()
        },
        /**
         * 加载项目详情
         */
        async loadProjectDetail() {
            const res = await getProjectDetail({ projectCode: this.projectCode })
            if (res.code === 200) {
                this.projectDetail = res.data
                this.pageTitle = this.generatePageTitle(res.data)
                console.log(this.pageTitle)
            } else {
                this.$message.error('获取项目详情失败')
            }
        },

        /**
         * 加载标书文件列表
         */
        async loadBidInvitationDocumentsList() {
            const res = await getBidInvitationDocumentsList({ projectCode: this.projectCode })
            if (res.code === 200) {
                this.tableData = res.data.records || []
                this.pagination.total = res.data.total || 0
                this.pagination.currentPage = res.data.current || 1
            } else {
                this.$handleApiError(res, '获取标书文件列表失败', this)
            }
        },
        /**
         * 删除标书文件
         */
        handleDeleteFile(row) {
            this.deleteBidInvitationDocuments(row.bidInvitationDocumentsCode)

        },
        /**
         * 删除标书文件
         */
        async deleteBidInvitationDocuments(bidInvitationDocumentsCode) {
            try {
                const res = await deleteBidInvitationDocuments({ bidInvitationDocumentsCode: bidInvitationDocumentsCode })
                if (res.code === 200) {
                    this.$message.success('删除成功')
                    this.loadBidInvitationDocumentsList()
                } else {
                    this.$handleApiError(res, '删除标书文件失败', this)
                }
            } catch (error) {
                this.$handleError(error, '删除标书文件失败', this)
            }
        },

        /**
         * 生成页面标题
         */
        generatePageTitle(projectData) {
            const projectTypeName = getProjectTypeName(projectData.projectType)
            return `${projectTypeName}--招标项目编号：${projectData.projectCode}　招标项目名称：${projectData.projectName}`
        },


        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 创建标书文件
        handleAdd() {
            this.$router.push({ path: '/agentHome/creatBidFile', query: { projectCode: this.projectCode } })
        },
        // 搜索
        handleSearch() {
            this.$message.info('搜索功能')
        },
        // 查看详情
        handleViewDetails(row) {
            this.$router.push({ path: '/agentHome/detailUploadFile', query: { bidInvitationDocumentsCode: row.bidInvitationDocumentsCode } })
        },
        // 查看下载记录
        handleViewDownloadRecord(row) {
            this.$router.push({ path: '/agentHome/uploadBidFile', query: { bidInvitationDocumentsCode: row.bidInvitationDocumentsCode } })
        },
        /**
         * 下载文件
         */
        handleDownloadFile(row) {
            this.getFileDownloadList(row.fileGuid)
        },

        /**
         * 获取文件下载列表
         */
        async getFileDownloadList(fileGuid) {
            if (!fileGuid) {
                this.$message.warning('文件标识不存在，无法下载')
                return
            }

            this.downloadLoading = true
            this.downloadDialogVisible = true

            try {
                const res = await getFileList(fileGuid)
                if (res.code === 200 && res.data) {
                    this.downloadFileList = res.data
                    if (this.downloadFileList.length === 0) {
                        this.$message.warning('暂无可下载的文件')
                    }
                } else {
                    this.$message.error(res.msg || '获取文件列表失败')
                    this.downloadDialogVisible = false
                }
            } catch (error) {
                console.error('获取文件下载列表失败:', error)
                this.$message.error('获取文件下载列表失败，请重试')
                this.downloadDialogVisible = false
            } finally {
                this.downloadLoading = false
            }
        },

        /**
         * 下载单个文件
         */
        handleDownloadSingleFile(fileInfo) {
            if (!fileInfo.fileUrl) {
                this.$message.error('文件下载地址不存在')
                return
            }

            try {
                // 创建隐藏的下载链接
                const link = document.createElement('a')
                link.href = fileInfo.fileUrl
                link.download = fileInfo.fileName || '下载文件'
                link.style.display = 'none'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)

                this.$message.success(`开始下载文件：${fileInfo.fileName}`)
            } catch (error) {
                console.error('下载文件失败:', error)
                this.$message.error('下载文件失败，请重试')
            }
        },

        /**
         * 格式化文件大小
         */
        formatFileSize(size) {
            if (!size || size === 0) return '0 B'

            const units = ['B', 'KB', 'MB', 'GB', 'TB']
            let unitIndex = 0
            let fileSize = size

            while (fileSize >= 1024 && unitIndex < units.length - 1) {
                fileSize /= 1024
                unitIndex++
            }

            return `${fileSize.toFixed(unitIndex === 0 ? 0 : 2)} ${units[unitIndex]}`
        },
        /**
         * 分页大小改变
         */
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadBidInvitationDocumentsList()
        },

        /**
         * 当前页改变
         */
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadBidInvitationDocumentsList()
        },
        //编辑
        handleEditFile(row) {
            console.log(row);
            
            this.$router.push({ path: '/agentHome/creatBidFile', query: { projectCode: this.projectCode,bidInvitationDocumentsCode:row.bidInvitationDocumentsCode } })
        }
    }

}
</script>

<style lang="less" scoped>
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

// ============================================
// 应用极简灰度主题
// ============================================
.agent-page {
    .apply-minimal-gray-theme();
}

// ============================================
// 页面特定样式
// ============================================

// 标段名称列表样式
.section-names {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .section-item {
        line-height: 1.6;
        word-break: break-all;
        color: @gray-600;
        font-size: 14px;
        padding: 2px 0;

        &:not(:last-child) {
            border-bottom: 1px solid @gray-200;
            padding-bottom: 4px;
        }
    }
}

// 页面头部优化
.page-header {
    margin-bottom: 20px;

    // .page-title {
    //     font-size: 20px;
    //     font-weight: 600;
    //     color: @gray-700;
    //     margin: 0;
    //     line-height: 1.5;
    //     position: relative;
    //     padding-left: 10px;

    //     &::before {
    //         content: '';
    //         position: absolute;
    //         left: 0;
    //         top: 50%;
    //         transform: translateY(-50%);
    //         width: 3px;
    //         height: 16px;
    //         background: @gray-700;
    //         border-radius: 2px;
    //     }

    //     &:first-child::before {
    //         background: @primary-color;
    //     }
    // }
}
</style>